<template>
  <div class="spacer-block" :style="spacerStyle">
    <div v-if="showGuides && isEditing" class="spacer-guides">
      <div class="guide-line guide-top"></div>
      <div class="guide-content">
        <i class="fas fa-arrows-alt-v"></i>
        <span>{{ height }}</span>
      </div>
      <div class="guide-line guide-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpacerBlock',
  props: {
    height: {
      type: String,
      default: '40px'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    borderTop: {
      type: String,
      default: 'none'
    },
    borderBottom: {
      type: String,
      default: 'none'
    },
    margin: {
      type: String,
      default: '0'
    },
    showGuides: {
      type: Boolean,
      default: true
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    spacerStyle() {
      return {
        height: this.height,
        backgroundColor: this.backgroundColor,
        borderTop: this.borderTop,
        borderBottom: this.borderBottom,
        margin: this.margin,
        width: '100%',
        position: 'relative',
        minHeight: '10px',
        boxSizing: 'border-box'
      }
    }
  }
}
</script>

<style scoped>
.spacer-block {
  width: 100%;
  position: relative;
}

.spacer-guides {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0.7;
}

.guide-line {
  width: 100%;
  height: 1px;
  background: repeating-linear-gradient(
    to right,
    #3b82f6 0px,
    #3b82f6 4px,
    transparent 4px,
    transparent 8px
  );
}

.guide-top {
  position: absolute;
  top: 0;
}

.guide-bottom {
  position: absolute;
  bottom: 0;
}

.guide-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: rgba(59, 130, 246, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #3b82f6;
  font-size: 11px;
  font-weight: 500;
  color: #3b82f6;
}

.guide-content i {
  font-size: 12px;
}

/* Estilos para cuando se hace hover sobre el spacer */
.spacer-block:hover .spacer-guides {
  opacity: 1;
}

/* Modo mínimo cuando no está editando */
.spacer-block:not(:hover) .spacer-guides {
  opacity: 0;
}
</style> 